
import Vue from "vue";
import Component from 'vue-class-component';

interface InvoiceItem {
    id: string;
    number: string;
    issueDate: string;
    seller: string;
    buyer: string;
    amount: string;
}

@Component
export default class InvoicesTab extends Vue {
    invoices: InvoiceItem[] = [];
    search: string = '';
    isLoading: boolean = true;

    get headers() {
        return [
            {
                text: 'Numer',
                align: 'start',
                sortable: true,
                value: 'number',
                width: '140',
            },
            { text: 'Data wystawienia', value: 'issueDate', width: '150' },
            { text: 'Wystawca', value: 'seller' },
            { text: 'Nabywca', value: 'buyer' },
            { text: 'Kwota', value: 'amount', width: '120' },
            { text: '', value: 'actions', sortable: false, width: '80' },
        ];
    }

    get filteredInvoices() {
        if (!this.search) return this.invoices;
        const phrase = this.search.toLowerCase();
        return this.invoices.filter(invoice =>
            invoice.number?.toLowerCase().includes(phrase) ||
            invoice.seller?.toLowerCase().includes(phrase) ||
            invoice.buyer?.toLowerCase().includes(phrase) ||
            invoice.amount?.toLowerCase().includes(phrase)
        );
    }

    downloadInvoice(invoice: InvoiceItem) {
        // TODO: Implement download when API is ready
        console.log('Download invoice:', invoice.number);
    }

    async mounted() {
        this.isLoading = true;
        try {
            // TODO: Load invoices from API when endpoint is available
            // this.invoices = await api.getInvoices();
            this.invoices = [];
        } catch (error) {
            console.error('Error loading invoices:', error);
        } finally {
            this.isLoading = false;
        }
    }
}
